/**
 * Shared CTL (Close The Loop) theme colors - Security 360 blue theme.
 * Single source of truth so pages/components across the CTL feature area
 * (CloseTheLoopPage, DCRRequests, etc.) stay visually consistent.
 */
export const THEME = {
    primary: "#0078D4",
    primaryLight: "#2B88D8",
    primaryDark: "#005A9E",
    background: "#F5F7FA",
    surface: "#FFFFFF",
    textPrimary: "#1A1A2E",
    textSecondary: "#5A5A72",
    border: "#E1E5EB",
    success: "#107C10",
    warning: "#FFB900",
    error: "#D13438",
    successBg: "#DFF6DD",
    warningBg: "#FFF4CE",
    errorBg: "#FDE7E9"
};
